// extracted by mini-css-extract-plugin
export default {"dot":"WWWUGKbOKtMcTa56NEbE","pulse":"be0eBvnZlfrtyEbbebqv","pulsate":"qWcJZNYqNbBq3r3Z2Koe"};